export default () => {
  const $readMoreBtn = $('.js-readMore__btn')
  const $readMoreDesc = $('.js-readMore__content')

  if (!$readMoreBtn.length || !$readMoreDesc.length) return

  const $window = $(window)
  let maxHeight = $readMoreDesc.attr('data-max-height')

  if ( !maxHeight ) return

  maxHeight = parseFloat(maxHeight)

  let descHeight = $readMoreDesc[0].scrollHeight

  function checkTextHeight() {
    descHeight = $readMoreDesc[0].scrollHeight
    console.log(descHeight, maxHeight)
    if (descHeight > maxHeight) {
      $readMoreBtn.addClass('is-visible')
      $readMoreDesc.addClass('has-overlay')
      $readMoreDesc.css({
        'max-height': maxHeight,
      })
      $readMoreBtn.removeClass('is-active')
    } else {
      $readMoreBtn.removeClass('is-visible')
      $readMoreDesc.removeClass('has-overlay')
      $readMoreDesc.css({
        'max-height': descHeight,
      })
      $readMoreBtn.addClass('is-active')
    }
  }

  checkTextHeight()
  $window.on('resize', function() {
    checkTextHeight()
  })

  setTimeout( () => {
    checkTextHeight()
  }, 1000)

  $window.trigger('resize')

  $readMoreBtn.on('click', function(e) {
    e.preventDefault()
    const $this = $(this)
    if ($this.hasClass('is-active')) {
      $readMoreDesc.css({
        'max-height': maxHeight,
      })
      $readMoreDesc.removeClass('is-opened')
      $this.removeClass('is-active')
    } else {
      $readMoreDesc.css({
        'max-height': descHeight,
      })
      $readMoreDesc.addClass('is-opened')
      $this.addClass('is-active')
    }
  })

}